import {inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {MapCenter} from '../modelinterfaces/map-center.model';
import {UserDetails} from '../modelinterfaces/user-details.model';
import {User} from '../modelinterfaces/user.model';
import {InstantRange} from "../app-interfaces/instant-range";
import {InstantRangeMapper} from "../app-components/date-controls/instant-range.mapper";
import {AuthRestService} from "../services/auth-rest.service";
import {KeycloakService} from "keycloak-angular";
import {Router} from "@angular/router";
import {Tab} from "../app-enums/tab";

@Injectable({
  providedIn: 'root'
})

export class AuthUserService {

  protected readonly authRestService: AuthRestService = inject(AuthRestService);
  private readonly keyclaokService: KeycloakService = inject(KeycloakService);
  private readonly router: Router = inject(Router);

  private _currentAuthUserSource = new BehaviorSubject<User | UserDetails>(undefined);
  private _realAuthUserSource = new BehaviorSubject<User>(undefined);

  public isAdmin = false;

  constructor() {}

  get currentUser$(): Observable<User> {
    return this._currentAuthUserSource.asObservable();
  }

  get currentUserDetails$(): Observable<UserDetails> {
    return this._currentAuthUserSource.asObservable().pipe(map(user => <UserDetails>user));
  }

  get timeZone$(): Observable<string> {
    return this._currentAuthUserSource.asObservable().pipe(
      map(user => user?.timeZone?.name)
    );
  }

  public init(): void {
    if (this._currentAuthUserSource.getValue()) {
      return;
    }
    this.update();
  }

  public update() {}

  public updateActAs(userId: number): void {}

  public change(user: User | UserDetails): void {
    this._currentAuthUserSource.next(user);
  }

  public changeRealAuthUser(user:User): void {
    this._realAuthUserSource.next(user);
  }

  public getInstant(): User {
    return this._currentAuthUserSource.getValue();
  }

  public getInstantDetails(): UserDetails {
    return <UserDetails>this._currentAuthUserSource.getValue();
  }

  public getInstantMapCenter(): MapCenter {
    return this._currentAuthUserSource.getValue()?.mapCenter;
  }

  public getInstantTimeZone(): string {
    return this._currentAuthUserSource.getValue()?.getUserTimeZone();
  }

  public getTodayRange$(): Observable<InstantRange> {
    return this.timeZone$.pipe(
      filter(timeZone => !!timeZone),
      map(() => InstantRangeMapper.today())
    );
  }

  public currentRealAuthUser(): Observable<User> {
    return this._realAuthUserSource.asObservable();
  }

  public logout(commands?: Tab[]): void {
    this.change(null);
    if (commands) {
      let fullUrl = window.location.origin + this.router.createUrlTree(commands).toString();
      this.keyclaokService.logout(fullUrl);
    } else {
      this.keyclaokService.logout();
    }
  }

  public destroy(): void {
    this._currentAuthUserSource.next(null);
  }
}
